<template>
  <div class="edit-category public-content">
    <div class="breadcrumb">{{$route.query.title}}</div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo">
        <el-form-item label="分类名称:">
          <el-input v-model="basicInfo.categoryName" ref="iptRef"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button round type="primary" @click="checkRepeat">确定</el-button>
    </div>
  </div>
</template>
 <script>
import { categoryUsable, categoryAdd, categoryUpdate, categoryGet, composeSizeUpdate } from '@/api/pms'
export default {
  name: 'edit-category',
  data () {
    return {
      basicInfo: JSON.parse(this.$route.query.detail)
    }
  },
  created () {
    ;
  },
  methods: {
    // 检查重复
    checkRepeat () {
      let name = {
        name: this.basicInfo.categoryName
      }
      categoryUsable(name).then((res) => {
        if (res.data.code === -1) {
          this.$message({
            type: 'error',
            message: '产品类重复'
          })
          this.$refs.iptRef.focus()
        } else if (res.data.success) {
          this.onsubmit()
        } else {
        }
      })
    },
    onsubmit () {
      if (this.$route.query.title === '添加分类') {
        this.basicInfo.level = 1
        this.basicInfo.pid = 0
        categoryAdd({ categoryId: this.basicInfo.id, categoryVo: this.basicInfo }).then((res) => {
          ;
          if (res.data.success) {
            this.$message.success('添加分类成功')
            this.$router.push('./procategory')
          } else {
          }
        })
      }
      if (this.$route.query.title === '编辑分类') {
        const _this = this
        categoryUpdate({ categoryId: this.basicInfo.id, categoryVo: this.basicInfo }).then((res) => {
          if (res.data.success) {
            this.$message.success('编辑分类成功')
            this.$router.push('./procategory')
          } else {
          }
        })
      }
    }
  }
}
</script>
 <style scoped>
</style>
